import { RootState } from 'plugins/store';
import { useEffect } from 'react';
import React from 'react';
import { setViewMode } from 'slices/viewModeSlice';
import { useAppDispatch, useAppSelector } from 'common/hook';
import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { applyTokenToUrl } from 'utils/helpers';

const isInIframe = window.self !== window.top;

const PreviewSurvey: React.FC = () => {
    const campaignId = useParams<{ id: string }>().id;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const viewMode = useAppSelector(
        (state: RootState) => state.viewMode.viewMode
    );
    const [iFrameUrl, setIFrameUrl] = React.useState(
        `${window.location.origin}/survey/${campaignId}`
    );

    const iframeStyles = {
        pc: {
            width: '100vw',
            height: '100vh',
        },
        tablet: {
            width: '1200px',
            height: '900px',
        },
        mobile: {
            width: '430px',
            height: '900px',
        },
    };

    useEffect(() => {
        if (!isInIframe) {
            const handleMessage = (event: MessageEvent) => {
                if (event.origin !== window.location.origin) return;
                const { type, payload } = event.data;

                if (type === 'CHANGE_MODE' && payload?.mode) {
                    dispatch(setViewMode(payload.mode));
                }
            };

            const backButton = (event: MessageEvent) => {
                if (event.origin !== window.location.origin) return;
                const { type, payload } = event.data;

                if (type === 'BACK_MODE' && payload?.mode) {
                    navigate(payload.mode);
                }
            };

            const replaceURL = (event: MessageEvent) => {
                if (event.origin !== window.location.origin) return;
                const { type, payload } = event.data;

                if (type === 'REPLACE_URL' && payload?.url) {
                    window.location.replace(payload.url);
                    setIFrameUrl(payload.url);
                }
            };

            window.addEventListener('message', handleMessage);
            window.addEventListener('message', backButton);
            window.addEventListener('message', replaceURL);
            return () => {
                window.removeEventListener('message', handleMessage);
                window.removeEventListener('message', backButton);
                window.removeEventListener('message', replaceURL);
            };
        }
    }, [dispatch, navigate]);

    return (
        <Box
            sx={{
                backgroundColor: '#EFF1FF',
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <iframe
                src={applyTokenToUrl(iFrameUrl)}
                style={{
                    ...iframeStyles[viewMode],
                    border: '1px solid #000',
                }}
                // Thiếu allow này thì trình duyệt chặn thẳng quyền vị trí trong
                // iframe, màn khảo sát sẽ không bao giờ qua được cổng vị trí.
                allow="geolocation"
                title="Responsive View"
            />
        </Box>
    );
};

export default PreviewSurvey;
